<template>
  <div id="app">
    <v-app>
      <div class="bg-layer d-flex justify-center">
        <div class="parent-frame">
          <Header v-if="!isBlacklist"></Header>
          <div class="child-frame"
            :class="{ 'no-header': isBlacklist, 'full-frame': isFullframe.includes($route.name), 'no-padding': isNoPadding }">
            <router-view class="default-class-component" />
          </div>
          <Footer></Footer>
        </div>
      </div>
    </v-app>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { headerBlacklist, noPadding } from './store/constants';

export default {
  components: {
    Header,
    Footer
  },
  computed: {
    isBlacklist: function () {
      return headerBlacklist.includes(this.$route.name)
    },
    isNoPadding: function () {
      return noPadding.includes(this.$route.name)
    }
  },
  data() {
    return {
      isFullframe: ['Home', 'ScanStation']
    }
  }
}
</script>

<style scoped lang="scss">
#app {
  font-family: 'Inter', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.bg-layer {
  background: #000;
  height: 100%;
}

.parent-frame {
  min-width: var(--frame-min-width);
  max-width: var(--frame-max-width);
  width: 100%;
  height: 100%;
  background: #fff;
  position: relative;
}

.child-frame {
  max-height: calc(100vh - (var(--footer-height) - (var(--scanner-btn-size) / 2)) - var(--header-height));
  overflow: auto;
  scrollbar-width: none;
  padding: 12px;
}

.child-frame::-webkit-scrollbar {
  display: none;
}

.no-header {
  max-height: calc(100vh - var(--footer-height));
}

.no-padding {
  padding: 0;
}

.full-frame {
  max-height: calc(100vh - (var(--footer-height) - (var(--scanner-btn-size) / 2)));
}

.default-class-component {
  position: relative;
  z-index: 1;
  height: 100%;
}
</style>
